import { MATOMO_SITE_ID, MATOMO_URL } from '../constants';

const matomoConfig = {
  ANALYTICS: {
    active: false,
    matomo_configuration: {
      urlBase: MATOMO_URL,
      siteId: MATOMO_SITE_ID,
      heartBeat: {
        active: true,
        seconds: 10
      }
    }
  }
};

export default matomoConfig;
